import { Injectable } from '@angular/core';
export class AuthTokenService {
/**
 * @param {?} jwt
 * @return {?}
 */
public getAuthToken(jwt: string): string {
    const /** @type {?} */ base64Url = jwt.split('.')[1];
    const /** @type {?} */ base64 = base64Url.replace('-', '+').replace('_', '/');
    const /** @type {?} */ parsed = JSON.parse(window.atob(base64));

    return parsed.authToken;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AuthTokenService_tsickle_Closure_declarations() {
/** @type {?} */
AuthTokenService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AuthTokenService.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
